// extracted by mini-css-extract-plugin
module.exports = {"hero-container":"blogLanding_hero-container___fOr9","heroContainer":"blogLanding_hero-container___fOr9"};